import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  IconButton,
} from "@mui/material";
import { Facebook, Twitter, Instagram, YouTube } from "@mui/icons-material";

const Footer = () => {
  const sections = [
    { id: "home", label: "Home" },
    { id: "activities-events", label: "Activities & Events" },
    { id: "watch-listen", label: "Watch/Listen" },
    { id: "resources", label: "Resources" },
    { id: "gallery", label: "Gallery" },
    { id: "become-member", label: "Become a Member / Join Us" },
    { id: "get-involved", label: "Get Involved" },
  ];
  const handleClick = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      //   setMobileOpen(false);
    }
  };
  return (
    <Box
      id="contact-us"
      sx={{
        // backgroundColor: "#333",
        background: "#000",
        color: "#fff",
        padding: "40px 0",
        marginTop: "auto",
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Logo and Address */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>
              <img
                src="./images/YF_transparent.png"
                alt="Logo"
                style={{ width: "150px", marginBottom: "10px" }}
              />
            </Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>
              We are launching Youth Forums in every village to empower young
              minds, foster collaboration, and instill civic responsibility.Each
              forum will consist of 20 dedicated members who will work together
              on community-driven initiatives while also setting personal goals
              for growth.
            </Typography>
          </Grid>

          <Grid item xs={6} md={4}>
            <Typography variant="h6" gutterBottom>
              Menus
            </Typography>
            {sections.map((list, index) => (
              <Link
                color="inherit"
                display="block"
                key={index}
                onClick={() => handleClick(list.id)}
                sx={{ cursor: "pointer" }}
              >
                {list.label}
              </Link>
            ))}
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>
              Contact Us
            </Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>
              123 Main Street, City, Country
            </Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>
              Email: info@example.com
            </Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>
              Phone: +123 456 7890
            </Typography>
          </Grid>
        </Grid>

        {/* Social Media Links */}
        <Box sx={{ textAlign: "center", mt: 4 }}>
          <IconButton href="#" color="inherit">
            <Facebook />
          </IconButton>
          <IconButton href="#" color="inherit">
            <Twitter />
          </IconButton>
          <IconButton href="#" color="inherit">
            <Instagram />
          </IconButton>
          <IconButton href="#" color="inherit">
            <YouTube />
          </IconButton>
        </Box>

        {/* Copyright */}
        <Box sx={{ textAlign: "center", mt: 4 }}>
          <Typography variant="body2">
            &copy; {new Date().getFullYear()} Youth Forum. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
